module.exports = __webpack_public_path__ + "static/media/Noboborsho-Typo.394ef445.jpg";